































































































import { Component, Prop, Vue } from 'vue-property-decorator';
import CriteriaPreview from '@/components/CriteriaPreview.vue';
import AudienceSearchToggle from '@/components/AudienceSearchToggle.vue';
import { AudienceSearchFilter } from '../models/AudienceSearchFilter';
import { AudienceDetails } from '../models/AudienceDetails';
import { Action, Getter } from 'vuex-class';
const namespace: string = 'counter';
import Common from '../helper/Common';
import { AudienceCampaign } from '../models/AudienceCampaign';
import { systemTimezone } from '../constants/general';

@Component({
    components: {
        CriteriaPreview,
        AudienceSearchToggle
    }
})
export default class AudienceSummary extends Vue {

    @Prop({ default: '' })
    public detailType!: string;
    @Prop({ default: null })
    public audienceLastSavedDetails!: AudienceDetails;
    @Prop({ default: null })
    public audienceLastPublishedDetails!: AudienceDetails;
    @Prop({ default: true })
    public loadDataOnMounted!: boolean;
    @Prop({ default: 0 })
    public audienceId!: number;
    @Prop({ default: null })
    public audienceCampaigns!: AudienceCampaign[];
    @Getter('currentClientId', { namespace })
    private clientId!: number;

    @Getter('currentIsSelectable', { namespace })
    private isAudienceSelectable!: boolean;

    private showLastSaved: boolean = false;
    private showLastPublished: boolean = false;

    private lastPublishedDate: string = '—';
    private lastSavedDate: string = '—';
    private timezone: string = '—';
    private totalRecords: string = '—';
    private campaignsUsing: string = '—';

    private previewSavedDetailId: number = 0;
    private previewPublishedDetailId: number = 0;
    private previewKeyS: number = 0;
    private previewKeyP: number = 0;
    private audienceSearchFilters: AudienceSearchFilter[] = [];
    private disabledToggle: boolean = false;
    private toggleFilter: AudienceSearchFilter = new AudienceSearchFilter(
        'audienceDetailType',
        'equals',
        'LastPublished');

    public loadComponent() {
        this.loadData();

        const published: any = this.$refs.publishedPreviewRef;
        const saved: any = this.$refs.savedPreviewRef;

        published.loadData();
        saved.loadData();
    }

    public setToggle(areTheSame: boolean, hasLastPublished: boolean) {
        if (areTheSame || !hasLastPublished) {
            this.toggleFilter.Value = (areTheSame) ? 'LastPublished' : 'LastSaved';
            this.disabledToggle = true;

            this.handleUpdateToggle();

            this.showLastSaved = true;
        } else {
            this.disabledToggle = false;
        }
    }

    public updateAssociatedCampaignsCount(campaigns: AudienceCampaign[]) {
        this.campaignsUsing = campaigns && campaigns.length > 0 ?
            campaigns.length.toString() : '—';
    }

    private mounted() {
        if (this.isAudienceSelectable) {
            this.detailType = 'LastPublished';
            this.showLastPublished = true;
            this.showLastSaved = false;
        }

        if (this.loadDataOnMounted) {
            this.loadData();
        }
    }

    private calculateTotalRecords(audienceType: string) {
        if (audienceType === 'LastSaved') {
            this.totalRecords = Common.formatCounts(this.audienceLastSavedDetails.CountTotal);
            if (this.audienceLastSavedDetails.hasCount === false) {
                this.totalRecords = '—';
            }
        } else if (audienceType === 'LastPublished') {
            this.totalRecords = Common.formatCounts(this.audienceLastPublishedDetails.CountTotal);
            if (this.audienceLastPublishedDetails.hasCount === false) {
                this.totalRecords = '—';
            }
        }
    }

    private loadData() {
        if (!this.isAudienceSelectable) {
            // set active toggle either saved or published
            if (!this.disabledToggle) {
                this.toggleFilter.Value = this.detailType;
            }
            // display saved or published criteria
            this.calculateTotalRecords(this.detailType);

            if (this.detailType === 'LastSaved') {
                this.showLastSaved = true;
            } else if (this.detailType === 'LastPublished') {
                this.showLastPublished = true;
            }

            this.previewSavedDetailId = this.audienceLastSavedDetails.AudienceDetailsID.valueOf();
            if (this.audienceLastPublishedDetails.AudienceDetailsID > 0) {
                this.previewPublishedDetailId = this.audienceLastPublishedDetails.AudienceDetailsID.valueOf();
                this.lastPublishedDate = this.formatDateForCard(this.audienceLastPublishedDetails.InsertDate);
            }
            this.lastSavedDate = this.formatDateForCard(this.audienceLastSavedDetails.UpdateDate);
            this.timezone = systemTimezone();

            this.handleUpdateToggle();
        } else {
            this.detailType = 'LastPublished';
            this.calculateTotalRecords(this.detailType);
            this.showLastPublished = true;

            this.lastSavedDate = this.formatDateForCard(this.audienceLastSavedDetails.UpdateDate);
            this.timezone = systemTimezone();

            this.previewPublishedDetailId = this.audienceLastPublishedDetails.AudienceDetailsID.valueOf();
            this.lastPublishedDate = this.formatDateForCard(this.audienceLastPublishedDetails.InsertDate);
        }
    }

    private handleUpdateToggle() {
        // if (!this.isAudienceSelectable) {
            const toggleRes: any = this.$refs.searchToggleRef;
            toggleRes.update();
        // }
    }

    private formatDateForCard(dateString: Date): string {
        //const date = new Date(dateString);
        //let output = date.toLocaleDateString(window.eInsightUserRegion);
        //output += ' ';
        //// add time without seconds
        //output += date.toLocaleTimeString(window.eInsightUserRegion).replace(/:\d\d([ ap]|$)/, '$1');
        //// output += date.toLocaleTimeString(); // HH:MM:SS PP
        //// const hour = (date.getHours() <= 12) ? date.getHours() : date.getHours() - 12;
        //// output += this.leftPadNumStr(hour, 2) + ':';
        //// output += this.leftPadNumStr(date.getMinutes(), 2) + ' ';
        //// output += date.getHours() <= 12 ? 'AM' : 'PM';
        const date = Common.formatDate(dateString.toString());
        const time = Common.formatTime(dateString.toString());
        let output = date + ' ' + time;
        return output;
    }

    private leftPadNumStr(num: number, pad: number): string {
        let output = num.toString();

        if (output.length < pad) {
            let padding = '';
            for (let i = 0; i < (pad - output.length); i++) {
                padding += '0';
            }
            output = padding + output;
        }

        return output;
    }

    private updateSearchResults(): void {
        const toggleRes: any = this.$refs.searchToggleRef;
        this.toggleFilter = toggleRes.ToggleFilterResults[0];

        if (this.toggleFilter.Value === 'LastPublished') {
            this.showLastPublished = true;
            this.showLastSaved = false;
        } else if (this.toggleFilter.Value === 'LastSaved') {
            this.showLastSaved = true;
            this.showLastPublished = false;
        }
        this.calculateTotalRecords(this.toggleFilter.Value);

        this.$nextTick(() => {
            const published: any = this.$refs.publishedPreviewRef;
            const saved: any = this.$refs.savedPreviewRef;

            published.updateSize();
            saved.updateSize();
        });
    }

    private displayingCriteria() {
        if (this.showLastPublished) {
            return 'LastPublished';
        } else {
            return 'LastSaved';
        }
    }
}
